import {
  AUTH_LOGIN, AUTH_LOGOUT, AUTH_LOGIN_OTP,
} from './actions.types'
import { AUTH_SET_LOGIN, AUTH_RESET_LOGIN } from './mutations.types'
import AuthService from '../services/auth.service'
import router from '../router/index'

const initialState = {
  profile: {
    rowkey: null,
    organizationKey: null,
    emailAddress: null,
    fullName: null,
    isStaff: false,
    isAdmin: false,
  },
  permissions: [],
  isLoggedIn: false,
  isSuperAdmin: false,
  isStaff: false,
  authToken: null,
  lastUpdated: null,
  clientIdentifier: 'vuex-pow-vue',
  loginErrors: [],
}

export const state = { ...initialState }

export const actions = {
  async [AUTH_LOGIN] ({ dispatch, commit, rootState }, payload) {
    try {
      // console.log('logging in with: ', payload)
      const response = await AuthService.login(payload)
      console.log('Login response: ', response.data)
      commit(AUTH_SET_LOGIN, response.data)
      return response.data
    } catch (e) {
      return false
      // throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Log in using a one-time use password
   * @param {string} payload.contact SMS/email address of the user
   * @param {string} payload.password password provided in SMS/email
   * @returns {*}
   */
  async [AUTH_LOGIN_OTP] ({ dispatch, commit, rootState }, payload) {
    try {
      // console.log('logging in with: ', payload)
      const response = await AuthService.loginOtp(payload)
      console.log('Login response: ', response.data)
      commit(AUTH_SET_LOGIN, response.data)
      return response.data
    } catch (e) {
      return false
      // throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  async [AUTH_LOGOUT] ({ dispatch, commit, rootState }, payload) {
    console.log('logging out')
    commit(AUTH_RESET_LOGIN)
    router.push('/login')
  },
}

export const mutations = {
  [AUTH_SET_LOGIN] (state, data) {
    state.profile.organizationKey = data.fk_organization_key
    state.profile.rowkey = data.rowkey
    state.profile.emailAddress = data.email_address
    state.profile.fullName = data.fullName
    state.profile.firstName = data.first_name
    state.profile.lastName = data.last_name
    state.profile.mobilePhone = data.mobile_number
    state.profile.phone = data.phone_number
    state.permissions = data.permissions
    state.authToken = data.token
    state.isLoggedIn = true
    state.isStaff = data.is_staff
    state.isAdmin = data.is_admin
    state.isSuperAdmin = data.is_super_admin
    state.lastUpdated = Date.now()
  },
  [AUTH_RESET_LOGIN] (state) {
    for (const prop in initialState) {
        state[prop] = initialState[prop]
    }
  },
}
export const getters = {
  bearerToken: state => state.authToken,
  isLoggedIn: state => state.isLoggedIn,
  authIsStaff: state => state.isStaff,
  isAdmin: state => state.isAdmin,
  profile: state => state.profile,
  permissions: state => state.permissions,
}

export default {
  state,
  actions,
  mutations,
  getters,
}
